export default __webpack_public_path__ + "static/media/no_photox.4f0f23f4.svg";